export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCfi3jEmtF46EfhA3d249hFN1-kGWdyw6E",
    authDomain: "helaba.cwl.camp",
    projectId: 'cwl-2a15987cf385-prod',
  },
  authParams: ['oidc.helaba', 'oidc.campfire'],
  signInType: "signInWithPopup",
  subscriptionServiceBaseURL: "https://helaba.api.deloitte.camp",
  chatBackendBaseURL: "https://helaba-planit.connect.api.deloitte.ai",
  product_id: "prd_9be8dcd0-eb27-4194-b1af-cd6754455aa6",
  aoh_url: "",
  store_url: "",
  products: {
    planit: true,
  },
  onboarding: {
    displayVideo: false,
    video_url: "",
    development: {
      frontend_url: "",
      backend_url: "",
      business_support_email: "",
    },
  },
  assetTitle: "PlanIT",
};
